<template>
  <v-flex layout pt-2 pb-2 pl-4 pr-4 row align-center>
    <v-flex style="max-width: 100px">
      <span>
        {{ $t('languageSelector.langOfPath') }}
      </span>
    </v-flex>
    <v-flex v-for="lang in langsEdited" :key="lang" style="max-width: 40px">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            style="width: 20px; height: 20px"
            :disabled="langsEdited.length === 1"
            @click="selectLangEdition(lang)"
          >
            <gb-flag
              :code="lang === 'en' ? 'gb' : lang"
              :size="sizeFlags[lang]"
            />
          </v-btn>
        </template>
        <span>
          {{ $tc('languageSelector.edit', $t('languages.' + lang)) }}
        </span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-icon
            size="15"
            color="red"
            class="deleteLangIcon"
            v-if="
              langsEdited.length > 1 &&
              lang !== langEdition &&
              lang !== locale &&
              type === 'path'
            "
            v-on="on"
            @click="askDeleteLangSelected(lang)"
          >
            mdi-close
          </v-icon>
        </template>
        <span>
          {{ $t('languageSelector.delete') }}
        </span>
      </v-tooltip>
    </v-flex>
    <v-flex v-if="type === 'path'" pl-2
      ><!--  && langToSelect.length>0 si plus d'upcomingFeature-->
      <v-btn icon dark class="ma-0" @click="askAddPathLanguage">
        <v-icon medium color="primary">mdi-plus-circle-outline</v-icon>
        <!--v-icon small color="yellow darken-2">mdi-star</v-icon-->
      </v-btn>
    </v-flex>

    <text-dialog
      v-if="typeTextDialog"
      :type="typeTextDialog"
      :isTextDialogOpen="isTextDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :details="
        path && path.langsPublished.includes(askDeleteLangValue)
          ? textDialogInformations[typeTextDialog].details
          : null
      "
      :cancelButtonText="
        textDialogInformations[typeTextDialog].cancelButtonText
      "
      :confirmButtonText="
        textDialogInformations[typeTextDialog].confirmButtonText
      "
      :confirmButtonColor="
        textDialogInformations[typeTextDialog].confirmButtonColor
      "
      :pathInfos="pathInfos"
      :accountInfos="accountInfos"
      :missionsInfos="missionsInfos"
      :checkListElements="checkListElements"
      :checkListPreviewMode="checkListPreviewMode"
      @cancel="notDeleteLang()"
      @delete-lang="deletePathLang()"
    >
    </text-dialog>
    <premium-dialog
      v-if="openPremiumDialog"
      :isTextDialogOpen="openPremiumDialog"
      :title="premiumTitle"
      :explanation="premiumExplanation"
      :lottieUrl="lottieUrl"
      @confirm="closePremium()"
      @close-text-dialog="closePremium()"
      @cancel="closePremium()"
    >
    </premium-dialog>
    <v-dialog width="600" v-model="askTranslate" consistent>
      <v-card>
        <v-flex layout align-center justify-center column>
          <v-card-text>
            <B> {{ $t('languageSelector.add') }} </B>
          </v-card-text>
          <v-card-text>
            {{ $t('languageSelector.addLanguages') }}
          </v-card-text>
          <v-card-text>
            {{ $t('languageSelector.automaticTranslate') }}
          </v-card-text>
          <v-flex layout row align-center>
            <v-btn
              icon
              v-for="lang in langToSelect"
              :key="lang"
              @click="changeLangToTranslate(lang)"
            >
              <gb-flag
                :code="lang === 'en' ? 'gb' : lang"
                :size="
                  targetTranslationLanguages.includes(lang) ? 'medium' : 'mini'
                "
              />
            </v-btn>
            <upcoming-feature
              :feature="
                $tc('languageSelector.upcomingLanguages', $t('languages.it'))
              "
              :featureType="'flag'"
              :featureFlag="'it'"
              :featureFlagSize="'mini'"
              :isTracked="'pathInLangIt'"
            />
            <upcoming-feature
              :feature="
                $tc('languageSelector.upcomingLanguages', $t('languages.de'))
              "
              :featureType="'flag'"
              :featureFlag="'de'"
              :featureFlagSize="'mini'"
              :isTracked="'pathInlangDe'"
            />
          </v-flex>
          <v-flex layout row block class="justify-space-between">
            <v-btn color="primary" outline @click="notTranslate">
              {{ $t('languageSelector.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="targetTranslationLanguages.length < 1"
              @click="translatePath"
            >
              {{ $t('languageSelector.confirmAndTranslate') }}
            </v-btn>
          </v-flex>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-flex>
</template>
<script>
import UpcomingFeature from './UpcomingFeature';
import TextDialog from './TextDialog';
import PremiumDialog from './PremiumDialog';

export default {
  name: 'languageSelector',
  components: {
    UpcomingFeature,
    TextDialog,
    PremiumDialog,
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    pathId: {
      type: String,
      default: null,
    },
    pathInfos: {
      type: Object,
      default: null,
    },
    missionsInfos: {
      type: Object,
      default: null,
    },
    accountInfos: {
      type: Object,
      default: null,
    },
    checkListElements: {
      type: Array,
      default: null,
    },
    checkListPreviewMode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      langsDispo: ['fr', 'en'],
      menu: false,
      hover: false,
      isTextDialogOpen: false,
      openPremiumDialog: false,
      typeTextDialog: null,
      askDeleteLangValue: '',
      askTranslate: false,
      targetTranslationLanguages: '',
      langEdition: '',
      lottieUrl: 'images/mountain.json',
      premiumTitle: this.$tc('premiumDialog.title.lang'),
      premiumExplanation: this.$tc('premiumDialog.explanation.lang'),
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    access() {
      return (
        this.$store.getters['paths/getPathsAccess'][
          this.$route.params.pathId
        ] || []
      );
    },
    langToSelect() {
      return this.langsDispo.filter((lang) => !this.langsEdited.includes(lang));
    },
    sizeFlags() {
      let sizeFlags = {};
      this.langsDispo.forEach((lang) => {
        if (lang === this.langEdition) {
          sizeFlags[lang] = 'medium';
        } else {
          sizeFlags[lang] = 'small';
        }
      });
      return sizeFlags;
    },
    path() {
      if (!this.pathId) {
        return;
      }
      return this.$store.getters['paths/getPathById'](this.pathId);
    },
    isPathEmpty() {
      return this.path.name[this.langEdition] === '' || !this.path.geolocation;
    },
    langsEdited() {
      if (this.path && this.path.langsEdited) {
        return this.path.langsEdited;
      }
      return ['fr'];
    },
    textDialogInformations() {
      return {
        deleteLang: {
          title: this.$tc(
            'languageSelector.textDialogInformations.deleteLang.title',
            this.$t('languages.' + this.askDeleteLangValue)
          ),
          explanation: this.$t(
            'languageSelector.textDialogInformations.deleteLang.explanation'
          ),
          details: this.$t(
            'languageSelector.textDialogInformations.deleteLang.details'
          ),
          cancelButtonText: this.$t('languageSelector.cancel'),
          confirmButtonText: this.$t(
            'languageSelector.textDialogInformations.deleteLang.confirm'
          ),
          confirmButtonColor: 'red',
        },
      };
    },
  },
  created() {
    this.setLang();
  },
  methods: {
    askAddPathLanguage() {
      this.askTranslate = true;
      if (!this.access.includes('lang')) {
        this.askTranslate = false;
        this.openPremiumDialog = true;
      }
    },
    askDeleteLangSelected(lang) {
      this.askDeleteLangValue = lang;
      this.typeTextDialog = 'deleteLang';
      this.isTextDialogOpen = true;
    },
    deletePathLang() {
      this.$emit('delete-path-lang', this.askDeleteLangValue);
      this.askDeleteLangValue = '';
      this.typeTextDialog = null;
      this.isTextDialogOpen = false;
    },
    notDeleteLang() {
      this.askDeleteLangValue = '';
      this.typeTextDialog = null;
      this.isTextDialogOpen = false;
    },
    changeLangToTranslate(lang) {
      if (this.targetTranslationLanguages.includes(lang)) {
        //si la langue était sélectionnée
        this.targetTranslationLanguages =
          this.targetTranslationLanguages.filter(
            (targetLang) => targetLang !== lang
          );
        console.log(this.targetTranslationLanguages);
      } else {
        this.targetTranslationLanguages = [
          ...this.targetTranslationLanguages,
          lang,
        ];
      }
    },
    notTranslate() {
      this.askTranslate = !this.askTranslate;
      this.targetTranslationLanguages = [];
    },
    translatePath() {
      this.askTranslate = !this.askTranslate;
      this.$emit('langs-path-to-translate', this.targetTranslationLanguages);
      this.selectLangEdition(this.targetTranslationLanguages[0]);
      this.targetTranslationLanguages = [];
    },
    changeModelTranslationLanguage(modelLang) {
      this.modelTranslationLanguage = modelLang;
    },
    selectLangEdition(lang) {
      this.langEdition = lang;
      this.$emit('change-lang-edition', this.langEdition);
    },
    setLang() {
      if (localStorage.getItem('pathLang') && this.access.includes('lang')) {
        this.langEdition = localStorage.getItem('pathLang');
      } else {
        this.langEdition = this.langsEdited[0];
      }
      this.$emit('change-lang-edition', this.langEdition);
    },
    closePremium() {
      console.log('close premium');
      this.isTextDialogOpen = false;
      this.openPremiumDialog = false;
    },
  },
  watch: {
    pathId(newValue) {
      this.setLang();
      return newValue;
    },
  },
};
</script>

<style lang="sass" scoped>

.deleteLangIcon
  position: absolute
  transform: translate(-50%, 0%)

.show-btns
  color: red !important;

.alignTextWithFlags
  padding-left: 5px;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 30px;

.alignIconWithFlags
  padding-right: 0px;
  padding-left: 0px;
  margin-top: 0px;
</style>
